"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CompanyFeatureEntitlementsSchema = exports.CompanyFeatureEntitlements = exports.OrganizationFeatureEntitlementsSchema = exports.OrganizationFeatureEntitlements = void 0;
const zod_1 = require("zod");
var OrganizationFeatureEntitlements;
(function (OrganizationFeatureEntitlements) {
    /**
     * Scripts management and execution on devices
     */
    OrganizationFeatureEntitlements["Scripts"] = "scripts";
    /**
     * Enables plugins management and execution on devices.
     */
    OrganizationFeatureEntitlements["Plugins"] = "plugins";
    /**
     * Enables runners management and execution on devices.
     */
    OrganizationFeatureEntitlements["Runners"] = "runners";
    /**
     * Define access to Remote Desktop functionality
     */
    OrganizationFeatureEntitlements["RemoteDesktop"] = "remoteDesktop";
    /**
     * Allows using Device policy - configuration and assignment
     */
    OrganizationFeatureEntitlements["DevicePolicy"] = "devicePolicy";
    /**
     * Packages - APK management - for Android devices
     */
    OrganizationFeatureEntitlements["PackagesManagement"] = "packagesManagement";
    /**
     * Enables remote FW upgrades - on device, bulk actions and policy
     */
    OrganizationFeatureEntitlements["FirmwareUpgrades"] = "firmwareUpgrades";
    /**
     * Android custom launcher configuration
     */
    OrganizationFeatureEntitlements["ManagedLauncher"] = "managedLauncher";
    /**
     * Access to on-demand screenshots stored within signageOS
     */
    OrganizationFeatureEntitlements["Screenshots"] = "screenshots";
    /**
     * Access to live stream of screenshots
     */
    OrganizationFeatureEntitlements["ScreenshotsLiveStream"] = "screenshotsLiveStream";
    /**
     * Access to historical screenshots stored within signageOS
     */
    OrganizationFeatureEntitlements["ScreenshotTimemachine"] = "screenshotTimemachine";
    /**
     * Access to definition of Alert Rules and incoming Alerts.
     */
    OrganizationFeatureEntitlements["AlertsManagement"] = "alertsManagement";
    /**
     * Alert rule types
     */
    OrganizationFeatureEntitlements["DeviceAlertRule"] = "deviceAlertRule";
    OrganizationFeatureEntitlements["PolicyAlertRule"] = "policyAlertRule";
    OrganizationFeatureEntitlements["AppletAlertRule"] = "appletAlertRule";
    OrganizationFeatureEntitlements["ScreenshotAlertRule"] = "screenshotAlertRule";
    /**
     * Enables bulk provisioning with device recipes
     */
    OrganizationFeatureEntitlements["BulkProvisioning"] = "bulkProvisioning";
    /**
     * Provides private VPN server and configuration for given organization.
     * Some devops is needed to fully enable this feature.
     */
    OrganizationFeatureEntitlements["VPN"] = "VPN";
    /**
     * Provides access to extra device management features unique for a given manufacturer.
     * Typically for Sony's ProSettings, BSN.cloud, Samsung'sTBM
     */
    OrganizationFeatureEntitlements["ExtendedControl"] = "extendedControl";
    /**
     * Telemetry data gathering, presenting and analysis
     */
    OrganizationFeatureEntitlements["TemperatureTelemetry"] = "temperatureTelemetry";
    OrganizationFeatureEntitlements["CPUTelemetry"] = "cpuTelemetry";
    OrganizationFeatureEntitlements["StorageTelemetry"] = "storageTelemetry";
    OrganizationFeatureEntitlements["UptimeTelemetry"] = "uptimeTelemetry";
    OrganizationFeatureEntitlements["RAMTelemetry"] = "ramTelemetry";
    OrganizationFeatureEntitlements["BrightnessTelemetry"] = "brightnessTelemetry";
    OrganizationFeatureEntitlements["BatteryTelemetry"] = "batteryTelemetry";
    OrganizationFeatureEntitlements["VolumeTelemetry"] = "volumeTelemetry";
    OrganizationFeatureEntitlements["PluginTelemetry"] = "pluginTelemetry";
    OrganizationFeatureEntitlements["RunnersTelemetry"] = "runnersTelemetry";
    OrganizationFeatureEntitlements["CustomRunnerTelemetry"] = "customRunnerTelemetry";
    OrganizationFeatureEntitlements["DateTimeTelemetry"] = "dateTimeTelemetry";
    OrganizationFeatureEntitlements["DebugTelemetry"] = "debugTelemetry";
    /**
     * REST API access and token creation
     */
    OrganizationFeatureEntitlements["RESTApi"] = "restApi";
    /**
     * AI ContentGuard and ContentGuard
     *
     * @todo: replace ScreenshotImageHashes with ContentGuard
     */
    OrganizationFeatureEntitlements["AIContentGuard"] = "aiContentGuard";
    OrganizationFeatureEntitlements["ContentGuard"] = "contentGuard";
    OrganizationFeatureEntitlements["ScreenshotImageHashes"] = "screenshotImageHashes";
    /**
     * Favorite items list
     */
    OrganizationFeatureEntitlements["Favorites"] = "favorites";
    /**
     * Creation and management of Locations and devices in locations
     */
    OrganizationFeatureEntitlements["Locations"] = "locations";
    /**
     * Feature In-location recovery that is delivered via P2P or local PC
     */
    OrganizationFeatureEntitlements["InLocationRecovery"] = "inLocationRecovery";
    /**
     * Tagging support for all signageOS entities
     */
    OrganizationFeatureEntitlements["Tags"] = "tags";
    /**
     * Bulk actions to perform multi-device configuration and operations
     */
    OrganizationFeatureEntitlements["BulkActions"] = "bulkActions";
    /**
     * Maintenance Windows - defining time ranges when devices are off-line and are not accessible
     * Includes Maintenance logs on device and Location
     */
    OrganizationFeatureEntitlements["MaintenanceWindows"] = "maintenanceWindows";
    /**
     * Enables Supra device support for remote content rendering on the local installed Supra server.
     */
    OrganizationFeatureEntitlements["SupraOnPremise"] = "supraOnPremise";
    /**
     * Restricts access to device details, device settings, and power actions, allowing devices to be used only as a repository.
     * Enables "cheap" or "free" plans and helps limit legacy customers on the Open plan.
     */
    OrganizationFeatureEntitlements["DeviceManagement"] = "deviceManagement";
    /**
     * Telemetry interval tier for DevSpace (development) environment.
     * Minimum telemetry check interval is 24 hours (practically disabled) - only keep-alive level.
     */
    OrganizationFeatureEntitlements["TelemetryIntervalDevSpace"] = "telemetryIntervalDevSpace";
    /**
     * Telemetry interval tier for Basic plan.
     * Minimum telemetry check interval is 6 hours, minimum screenshot interval is 24 hours.
     */
    OrganizationFeatureEntitlements["TelemetryIntervalBasic"] = "telemetryIntervalBasic";
    /**
     * Telemetry interval tier for Pro plan.
     * Minimum telemetry check interval is 3 hours, minimum screenshot interval is 60 minutes.
     */
    OrganizationFeatureEntitlements["TelemetryIntervalPro"] = "telemetryIntervalPro";
    /**
     * Telemetry interval tier for Ultra plan.
     * Minimum telemetry check interval is 5 minutes, minimum screenshot interval is 15 minutes.
     */
    OrganizationFeatureEntitlements["TelemetryIntervalUltra"] = "telemetryIntervalUltra";
})(OrganizationFeatureEntitlements || (exports.OrganizationFeatureEntitlements = OrganizationFeatureEntitlements = {}));
exports.OrganizationFeatureEntitlementsSchema = zod_1.z.nativeEnum(OrganizationFeatureEntitlements);
/**
 * Enum representing the available feature entitlements for a signageOS company account.
 * These entitlements control access to platform capabilities and development environments within DevSpace.
 */
var CompanyFeatureEntitlements;
(function (CompanyFeatureEntitlements) {
    /**
     * Grants access to the general CloudControl environment for device management.
     */
    CompanyFeatureEntitlements["CloudControl"] = "cloudControl";
    /**
     * Grants access to the general DevSpace environment for applet development, CoreApp building, and debugging.
     */
    CompanyFeatureEntitlements["DevSpace"] = "devSpace";
    /**
     * Enables Single Sign-On (SSO) integration for the company's users.
     */
    CompanyFeatureEntitlements["SSO"] = "sso";
    /**
     * Allows the company to securely store and manage sensitive data such as API keys or credentials and send them to devices.
     */
    CompanyFeatureEntitlements["Secrets"] = "secrets";
    /**
     * Unlocks expert-mode settings across the signageOS platform, intended for power users.
     */
    CompanyFeatureEntitlements["GodMode"] = "godMode";
    /**
     * Provides prioritized technical support from signageOS. Used on support section.
     */
    CompanyFeatureEntitlements["PrioritySupport"] = "prioritySupport";
    /**
     * Grants access to build Tizen CoreApps with built-in applet within the DevSpace environment.
     */
    CompanyFeatureEntitlements["DevSpaceTizen"] = "devSpaceTizen";
    /**
     * Grants access to build Tizen TEP CoreApps with built-in applet within the DevSpace environment - Tizen 6.5 and above.
     */
    CompanyFeatureEntitlements["DevSpaceTizenTEP"] = "devSpaceTizenTEP";
    /**
     * Grants access to build Tizen EPapaer CoreApps with built-in applet within the DevSpace environment - Only Tizen Epaper.
     */
    CompanyFeatureEntitlements["DevSpaceTizenEPaper"] = "devSpaceTizenEPaper";
    /**
     * Grants access to build webOS CoreApps with built-in applet within the DevSpace environment.
     */
    CompanyFeatureEntitlements["DevSpaceWebOS"] = "devSpaceWebOS";
    /**
     * Grants access to build webOS IDCap CoreApps with built-in applet within the DevSpace environment.
     */
    CompanyFeatureEntitlements["DevSpaceWebOSIDCap"] = "devSpaceWebOSIDCap";
    /**
     * Grants access to build BrightSign CoreApps with built-in applet within the DevSpace environment.
     */
    CompanyFeatureEntitlements["DevSpaceBrightSign"] = "devSpaceBrightsign";
    /**
     * Grants access to build BrightSign CoreApps with built-in applet within the DevSpace environment.
     */
    CompanyFeatureEntitlements["DevSpaceBrightSignNine"] = "devSpaceBrightsign9";
    /**
     * Grants access to build Linux Yocto CoreApps with built-in applet within the DevSpace environment.
     */
    CompanyFeatureEntitlements["DevSpaceLinux"] = "devSpaceLinux";
    /**
     * Grants access to build Linux Ubuntu CoreApps with built-in applet within the DevSpace environment.
     */
    CompanyFeatureEntitlements["DevSpaceLinuxUbuntu"] = "devSpaceLinuxUbuntu";
    /**
     * Grants access to build Linux Debian CoreApps with built-in applet within the DevSpace environment.
     */
    CompanyFeatureEntitlements["DevSpaceLinuxDebian"] = "devSpaceLinuxDebian";
    /**
     * Grants access to build Linux Fedora CoreApps with built-in applet within the DevSpace environment.
     */
    CompanyFeatureEntitlements["DevSpaceLinuxFedora"] = "devSpaceLinuxFedora";
    /**
     * Grants access to build Linux CoreApps with built-in applet within the DevSpace environment.
     */
    CompanyFeatureEntitlements["DevSpaceRaspberryPi"] = "devSpaceRaspberryPi";
    /**
     * Grants access to build generic Android 4.4 up to 9 included (tables, non-branded devices) CoreApps with built-in applet within the DevSpace environment.
     */
    CompanyFeatureEntitlements["DevSpaceAndroidLegacy"] = "devSpaceAndroidLegacy";
    /**
     * Grants access to build generic Android 10+ (tables, non-branded devices) CoreApps with built-in applet within the DevSpace environment.
     */
    CompanyFeatureEntitlements["DevSpaceAndroid"] = "devSpaceAndroid";
    /**
     * Grants access to build Sony CoreApps with built-in applet within the DevSpace environment.
     * Despite Sony is powered by Android, we separate that to push customers to define which brands they want to use.
     * We use named list of brands/vendors in our contracts.
     */
    CompanyFeatureEntitlements["DevSpaceSony"] = "devSpaceSony";
    /**
     * Grants access to build Philips CoreApps with built-in applet within the DevSpace environment.
     * Despite Philips is powered by Android, we separate that to push customers to define which brands they want to use.
     * We use named list of brands/vendors in our contracts.
     */
    CompanyFeatureEntitlements["DevSpacePhilips"] = "devSpacePhilips";
    /**
     * Grants access to build Elo CoreApps with built-in applet within the DevSpace environment.
     * Despite Elo is powered by Android, we separate that to push customers to define which brands they want to use.
     * We use named list of brands/vendors in our contracts.
     */
    CompanyFeatureEntitlements["DevSpaceElo"] = "devSpaceElo";
    /**
     * Grants access to build SSSP CoreApps with built-in applet within the DevSpace environment.
     */
    CompanyFeatureEntitlements["DevSpaceSSSP"] = "devSpaceSSSP";
    /**
     * Grants access to build Windows CoreApps with built-in applet within the DevSpace environment.
     */
    CompanyFeatureEntitlements["DevSpaceWindows"] = "devSpaceWindows";
    /**
     * 	Grants access to build ChromeOS CoreApps with built-in applet within the DevSpace environment.
     */
    CompanyFeatureEntitlements["DevSpaceChromeOS"] = "devSpaceChromeOS";
    /**
     * DevSpace capabilities unlocking specific JS APIs.
     */
    CompanyFeatureEntitlements["DevSpaceManagementAPI"] = "devSpaceManagementAPI";
    CompanyFeatureEntitlements["DevSpaceSyncAPI"] = "devSpaceSyncAPI";
    CompanyFeatureEntitlements["DevSpaceContentAPI"] = "devSpaceContentAPI";
    CompanyFeatureEntitlements["DevSpacePoPAPI"] = "devSpacePoPAPI";
    /**
     * DevSpace features for plans unlocing additional features and capabilities.
     */
    CompanyFeatureEntitlements["DevSpaceBrandedApps"] = "devSpaceBrandedApps";
    CompanyFeatureEntitlements["DevSpaceAppHosting"] = "devSpaceAppHosting";
    CompanyFeatureEntitlements["DevSpaceRemoteTestingLab"] = "devSpaceRemoteTestingLab";
    CompanyFeatureEntitlements["DevSpaceCustomHardwareOnboarding"] = "devSpaceCustomHardwareOnboarding";
    /**
     * RBAC custom roles definitions
     */
    CompanyFeatureEntitlements["CustomRolesDefinition"] = "customRolesDefinition";
    /**
     * MFA for users secure logging
     */
    CompanyFeatureEntitlements["MFA"] = "mfa";
    /**
     * Management of a Company Network by partner companies like Sony or MoodMedia
     */
    CompanyFeatureEntitlements["CompanyNetworkManagement"] = "companyNetworkManagement";
})(CompanyFeatureEntitlements || (exports.CompanyFeatureEntitlements = CompanyFeatureEntitlements = {}));
exports.CompanyFeatureEntitlementsSchema = zod_1.z.nativeEnum(CompanyFeatureEntitlements);
